import { cx } from '@linaria/core';
import { useNotifier } from '@provider/notifier';
import { avoidBreakInside } from '@provider/print';
import { useAudio } from '@utils/react';
import { content, text, title, wrapper } from './_player.style.js';
import { Description } from './atom.description.js';
import { description } from './atom.description.style.js';
import { LeftGraphic } from './atom.left-graphic.js';
import { Controls } from './molecule.controls.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function AudioPlayer(props) {
  const notifier = useNotifier();
  const audio = useAudio({
    src: props.src,
    autoplay: false,
    notifier
  });
  return /*#__PURE__*/jsxs("div", {
    className: cx(wrapper, props.className),
    ...avoidBreakInside(),
    children: [/*#__PURE__*/jsx(LeftGraphic, {
      imageSrc: props.imageSrc,
      audio: audio,
      disabled: props.isScrambled
    }), /*#__PURE__*/jsxs("div", {
      className: content,
      children: [/*#__PURE__*/jsxs("div", {
        className: text,
        children: [props.caption.title?.value && /*#__PURE__*/jsx("h4", {
          className: title,
          "data-scrambled": props.isScrambled,
          children: props.caption.title?.value
        }), audio.didError ? /*#__PURE__*/jsx("span", {
          className: description,
          children: "Der opstod en fejl under indl\xE6sningen af lydfilen."
        }) : /*#__PURE__*/jsx(Description, {
          caption: props.caption,
          isScrambled: props.isScrambled
        })]
      }), /*#__PURE__*/jsx(Controls, {
        audio: audio,
        disabled: props.isScrambled
      })]
    })]
  });
}

export { AudioPlayer };
//# sourceMappingURL=_player.js.map
